module.exports = __webpack_public_path__ + "img/facepaint-4_cn.e4a0c03.jpg";